// extracted by mini-css-extract-plugin
export var navigation = "nav-module--navigation--ja4bz";
export var navList = "nav-module--nav-list--3-U2k";
export var navItem = "nav-module--nav-item--16yfH";